import React, { useCallback, useContext, useEffect, useState } from "react";
import NextPreviousSection from "../NextPreviousSection.jsx/NextPreviousSection";
import { t } from "i18next";
import SupervisorSignCheck from "../../../Hospital/components/SupervisorSignCheck/SupervisorSignCheck";
import CustomCheckBox from "../../../Hospital/components/HeaderFileChecks/CustomCheckBox";
import {
  Checkbox,
  ChoiceGroup,
  ComboBox,
  Dropdown,
  SelectableOptionMenuItemType,
  TextField,
  IconButton,
} from "@fluentui/react";
import { ACTIONS, USERTYPES } from "../../../../constants/Constants";
import { values } from "underscore";
import {
  getModalityList,
  getSubModalityListNumbers,
} from "../../../../service/FirmServices";
import Select from "react-select";
import { PrimaryButton } from "@fluentui/react";
import "../../firm.css";
import { FieldArray, Field, getIn, FormikProvider } from "formik";
import themeContext from "../../../../context/theme/ThemeContext";
import { getTimeZones } from "@vvo/tzdb";
import { getEnv } from '../../../../helpers/EnvHelper';
import AiDraftSiteSettings from "./AiDraftSiteSettings";


const TZ_ALIAS_MAP = {
  "Asia/Calcutta": "Asia/Kolkata",
  "Asia/Saigon": "Asia/Ho_Chi_Minh",
  "US/Eastern": "America/New_York",
  "US/Central": "America/Chicago",
  "US/Mountain": "America/Denver",
  "US/Pacific": "America/Los_Angeles",
  "US/Arizona": "America/Phoenix",
  "US/Alaska": "America/Anchorage",
  "US/Hawaii": "Pacific/Honolulu",
  "GMT": "Etc/GMT",
  "UTC": "Etc/UTC",
  "Etc/UCT": "Etc/UTC",
  "Etc/Universal": "Etc/UTC",
  "Etc/Zulu": "Etc/UTC",
  "W-SU": "Europe/Moscow",
  "Eire": "Europe/Dublin",
  "Hongkong": "Asia/Hong_Kong",
  "ROC": "Asia/Taipei",
  "Egypt": "Africa/Cairo",
  "Turkey": "Europe/Istanbul"
};

const normalizeTZ = (tz) => {
  if (!tz) return "UTC";
  return TZ_ALIAS_MAP[tz] || tz;
};


const timeZoneOptions = [
  ...getTimeZones().map(tz => {
    const offset = tz.rawOffsetInMinutes / 60;

    return {
      value: tz.name,
      label: `${tz.name} (UTC${offset >= 0 ? "+" : ""}${offset})`
    };
  })
];



const choiceGroupStyles = {
  label: {
    display: "inline",
  },
  flexContainer: {
    columnGap: "1em",
    flexDirection: "row",
    flexWrap: "wrap",
  },
};

const HospitalSettings = (props) => {
  const { theme, themeName ,getThemeColor} = useContext(themeContext);
  let enterprise =
    getEnv("REACT_APP_ENTERPRISE_PLATFORM") == "true" ||
    getEnv("REACT_APP_ENTERPRISE_PLATFORM") == true
      ? true
      : false;

  let isBucketManagement = (getEnv("REACT_APP_BUCKET_MANAGEMENT_ENABLED") == "true" || getEnv("REACT_APP_BUCKET_MANAGEMENT_ENABLED") == true) ? true : false;
  let isEnableWhatsApp =   (getEnv("REACT_APP_ENABLE_WHATSAPP") == "true" || getEnv("REACT_APP_ENABLE_WHATSAPP") == true) ? true : false;

  const [enablePrintDisclaimerText, setEnablePrintDisclaimerText] = useState(
    props.values.addPrintDisclaimer
  );
  const [enableAddendumDisclaimerText, setEnableAddendumDisclaimerText] =
    useState(props.values.addendumDisclaimerEnabled);
  const [addSupervisorSignature, setAddSupervisorSignature] = useState(
    props.values.addSupervisorSignature
  );
  const [qcEnabled, setQcEnabled] = useState(
    props.values.qcEnabled || props.values.preliminaryQcEnabled
  );
  const [preliminaryQcEnabled, setPreliminaryQcEnabled] = useState(
    !!props.values.preliminaryQcEnabled
  );
  const [technicianContactMandatory,setTechnicianContactMandatory] = useState(props.values.technicianContactMandatory);
  const [autoAssignEnabled, setAutoAssignEnabled] = useState(
    props.values.autoAssignEnable
  );
  const [historyAvailable, setHistoryAvailable] = useState(
    props.values.historyAvailable
  );

  const [selectedHistoryModality, setSelectedHistoryModality] = useState(
    props.values.historyModalityIds
  );
  const [selectedModality, setSelectedModality] = useState(
    props.values.modalityIds
  );
  const [selectedAutoAssignModality, setSelectedAutoAssignModality] = useState(
    props.values.autoAssignModalityIds
  );
  const [enableShareReportLink, setEnableShareReportLink] = useState(
    props.values.enableShareReportLink
  );
  const [enableUnassignmentService, setEnableUnassignmentService] = useState(props.values.enableUnassignmentService);
  const [selectedUnassignmentModality, setSelectedUnassignmentModality] = useState(
    Array.isArray(props.values.unassignmentModalityIds)
      ? props.values.unassignmentModalityIds
      : []
  );

  const bucketOptions = props.bucketList.slice(2).map(bucket => ({
    key: bucket.id,
    text: bucket.bucketName
  }));
  const [userTimeZone, setUserTimeZone] = useState("__SYSTEM__");

  // const [showWord, setShowWord] = useState(props.values.showWord);

  const [modalityList, setModalityList] = useState([]);

  const mdl = [
    { key: "DX", text: "DX" },
    { key: "CT", text: "CT" },
    { key: "CR", text: "CR" },
    { key: "MR", text: "MR" },
    { key: "DEFAULT", text: "DEFAULT" },
  ];
  const [bucketModalityList, setBucketModalityList] = useState(mdl);
  const [supervisor2Signtaure, setSupervisor2Signature] = useState(
    props.values.signature2Dto.signatureFile2?.name
  );
  const [supervisor3Signtaure, setSupervisor3Signature] = useState(
    props.values.signature3Dto.signatureFile3?.name
  );
  const [subModalityListNumbers, setSubModalityListNumbers] = useState([]);

  const [signature2Image, setSignature2Image] = useState(
    props.signature2ImageValue ? true : false
  );
  const [signature3Image, setSignature3Image] = useState(
    props.signature3ImageValue ? true : false
  );
  const [historyModalityList, setHistoryModalityList] = useState([]);
  let isVdcPlatform = (getEnv("REACT_APP_VDC_PLATFORM")=="true"||getEnv("REACT_APP_VDC_PLATFORM")==true)?true:false;


  const effectiveTimeZone =
  props.values.firmTimeZone ||
  getEnv("REACT_APP_BACKEND_TIMEZONE") ||
  null;

  useEffect(() => {
    const modalities = selectedUnassignmentModality.length > 0 ? selectedUnassignmentModality : [];
    props.values.unassignmentModalityIds = modalities;
    props.setFieldValue?.("unassignmentModalityIds", modalities);
  }, [selectedUnassignmentModality]);

  useEffect(() => {
    if (props.roles[0] === USERTYPES.FIRMADMIN) {
      fetchSubModalityListNumbers();
    }
  }, [props.roles]);

  const fetchSubModalityListNumbers = async () => {
    const response = await getSubModalityListNumbers();
    console.log(response);
    if (response.status === 200) {
      let mdl = [];
      response.data.data.map((listnum) => {
        mdl.push({
          key: listnum,
          text: listnum,
        });
      });
      setSubModalityListNumbers(mdl);
    }
  };

  useEffect(() => {
    console.log(subModalityListNumbers);
  }, [subModalityListNumbers]);

  const fetchModalityList = async () => {
    const response = await getModalityList();
    if (response.status === 200) {
      // setModalityList([{ key: 0, modality: "Select all" }]);
      // let mdl = [{ key: "selectAll", text: "Select all" }];
      let mdl = [];
      response.data.data.map((modality) => {
        mdl.push({
          key: modality.id,
          text: modality.name,
        });
      });
      setModalityList(mdl);
    }
  };

  const fetchHistoryModalityList = async () => {
    const response = await getModalityList();
    if (response.status === 200) {
      // setModalityList([{ key: 0, modality: "Select all" }]);
      // let mdl = [{ key: "selectAll", text: "Select all" }];
      let mdl = [];
      response.data.data.map((modality) => {
        mdl.push({
          key: modality.id,
          text: modality.name,
        });
      });
      setHistoryModalityList(mdl);
    }
  };

  useEffect(() => {
    if (historyModalityList.length === 0) fetchHistoryModalityList();
  }, [historyAvailable]);

  useEffect(() => {
    if (modalityList.length === 0) fetchModalityList();
  }, [autoAssignEnabled]);

  useEffect(() => {
    props.values.autoAssignModalityIds = selectedAutoAssignModality;
  }, [selectedAutoAssignModality]);

  useEffect(() => {
    console.log("selectedModality", selectedModality, modalityList);
    props.values.modalityIds = selectedModality;
  }, [selectedModality]);

  useEffect(() => {
    props.values.historyModalityIds = selectedHistoryModality;
  }, [selectedHistoryModality]);

  const choiceGroupStyles = {
    label: {
      display: "inline",
    },
    flexContainer: {
      columnGap: "1em",
      display: "inline-flex",
      flexDirection: "row",
      flexWrap: "wrap",
    },
  };

  useEffect(() => {}, [enablePrintDisclaimerText]);

  useEffect(() => {
    if (!addSupervisorSignature) {
      props.handleClearImage("signature3");
      setSignature3Image(false);
      props.values.signature2Dto.signatureFile3 = null;
      props.setIsSignatureFile3Deleted(true);
      props.values.signature3Dto.isSignatureImageDeleted = 1;
    }
  }, [addSupervisorSignature]);

  useEffect(() => {
    if (!addSupervisorSignature) {
      props.handleClearImage("signature2");
      setSignature2Image(false);
      props.values.signature2Dto.signatureFile2 = null;
      props.setIsSignatureFile2Deleted(true);
      props.values.signature2Dto.isSignatureImageDeleted = 1;
    }
  }, [addSupervisorSignature]);

  // let modalityList = [];
  // props.modalityList?.map((modality) => {
  //   modalityList.push({
  //     key: modality.id,
  //     text: modality.name,
  //   });
  // });

  const addTimeToReportOptions = [
    {
      key: "true",
      text: "Yes",
    },
    {
      key: "false",
      text: "No",
    },
  ];

  const setAddTimeToReport = useCallback((e, option) => {
    props.values.addTimeToReport = option.key === "true" ? true : false;
  });

  const addDateToReportOptions = [
    {
      key: "true",
      text: "Yes",
    },
    {
      key: "false",
      text: "No",
    },
  ];

  const setAddDateToReport = useCallback((e, option) => {
    props.values.addDateToReport = option.key === "true" ? true : false;
  });

  const historyAvailableOptions = [
    {
      key: "true",
      text: "Yes",
    },
    {
      key: "false",
      text: "No",
    },
  ];

  // const setHistoryAvailable = useCallback((e, option) => {
  //   props.values.historyAvailable = option.key === "true" ? true : false;
  // });

  const activeStatusOptions = [
    {
      key: "true",
      text: "Active",
    },
    {
      key: "false",
      text: "Inactive",
    },
  ];

  const setActive = useCallback((e, option) => {
    props.values.active = option.key === "true" ? true : false;
  });

  const enableShareReportLinkOptions = [
    {
      key: "true",
      text: "Yes",
    },
    {
      key: "false",
      text: "No",
    },
  ];

  const setEnableShareReportLinkValue = useCallback((e, option) => {
    props.values.enableShareReportLink = option.key === "true" ? true : false;
    setEnableShareReportLink(props.values.enableShareReportLink);
  });

  const addPrintDisclaimerOptions = [
    {
      key: "true",
      text: "Yes",
    },
    {
      key: "false",
      text: "No",
    },
  ];

  const setAddPrintDisclaimerValue = useCallback((e, option) => {
    props.values.addPrintDisclaimer = option.key === "true" ? true : false;
    setEnablePrintDisclaimerText(props.values.addPrintDisclaimer);
  });

  const setAddendumDisclaimerEnabledValue = useCallback((e, option) => {
    props.values.addendumDisclaimerEnabled =
      option.key === "true" ? true : false;
    setEnableAddendumDisclaimerText(props.values.addendumDisclaimerEnabled);
  });

  const qcEnabledOptions = [
    {
      key: "true",
      text: "Yes",
    },
    {
      key: "false",
      text: "No",
    },
  ];

  const setQcEnabledValue = useCallback((e, option) => {
    props.values.qcEnabled = option.key === "true" ? true : false;
    setQcEnabled(props.values.qcEnabled);
  });

  const twoSignaturesAllowedOptions = [
    {
      key: "true",
      text: "Yes",
    },
    {
      key: "false",
      text: "No",
    },
  ];

  const setTwoSignaturesAllowedValue = useCallback((e, option) => {
    props.values.twoSignaturesAllowed = option.key === "true" ? true : false;
  });

  const autoAssignEnableOptions = [
    {
      key: "true",
      text: "Yes",
    },
    {
      key: "false",
      text: "No",
    },
  ];

  const setAutoAssignEnableValue = useCallback((e, option) => {
    props.values.autoAssignEnable = option.key === "true" ? true : false;
    setAutoAssignEnabled(props.values.autoAssignEnable);
  });

  const allowedFileTypes = [".JPEG", ".jpeg", ".PNG", ".png", ".JPG", ".jpg"];

  // add near other state declarations
const [allowFirmAdminSetClientComm, setAllowFirmAdminSetClientComm] = useState(
  !!props.values?.allowFirmAdminSetClientComm
);
const [firmAdminCanEnableWhatsapp, setFirmAdminCanEnableWhatsapp] = useState(
  !!props.values?.firmAdminCanEnableWhatsapp
);
const [firmAdminCanEnableEmail, setFirmAdminCanEnableEmail] = useState(
  props.values?.firmAdminCanEnableEmail != null ? !!props.values.firmAdminCanEnableEmail : true
);

const showReportLinkSettings =
  (props.action === ACTIONS.ADD && props.roles[0] === USERTYPES.ADMIN) ||
  (props.action === ACTIONS.EDIT &&(
    (props.roles[0] === USERTYPES.ADMIN && props.values.isMinimalAccount === 0) ||
    (props.roles[0] === USERTYPES.FIRMADMIN && props.ownFirm))) ||
  (props.action === ACTIONS.VIEW &&(
    (props.roles[0] === USERTYPES.ADMIN && props.values.isMinimalAccount === 0) ||
    (props.roles[0] === USERTYPES.FIRMADMIN && props.ownFirm)));


const showCriticalAlertSetting =
  (props.action === ACTIONS.ADD && props.roles[0] === USERTYPES.ADMIN) ||
  (props.action === ACTIONS.EDIT && (
    (props.roles[0] === USERTYPES.ADMIN && props.values.isMinimalAccount === 0) ||
    (props.roles[0] === USERTYPES.FIRMADMIN && props.ownFirm))) ||
  (props.action === ACTIONS.VIEW && (
    (props.roles[0] === USERTYPES.ADMIN && props.values.isMinimalAccount === 0) ||
    (props.roles[0] === USERTYPES.FIRMADMIN && props.ownFirm)));

const showStudyLinkSettings =
  props.roles[0] === USERTYPES.ADMIN ||
  props.roles[0] === USERTYPES.FIRMADMIN;

    const showViewStudyLinkSettings =
  (props.ownFirm ||
    ((props.roles[0] === USERTYPES.ADMIN && props.values.isMinimalAccount === 0))) &&
  !props.values.isClientWarning;
// keep in sync when props change (watch specific keys)
useEffect(() => {
  setAllowFirmAdminSetClientComm(!!props.values?.allowFirmAdminSetClientComm);
}, [props.values?.allowFirmAdminSetClientComm]);

useEffect(() => {
  setFirmAdminCanEnableWhatsapp(!!props.values?.firmAdminCanEnableWhatsapp);
}, [props.values?.firmAdminCanEnableWhatsapp]);

useEffect(() => {
  setFirmAdminCanEnableEmail(props.values?.firmAdminCanEnableEmail != null ? !!props.values.firmAdminCanEnableEmail : true);
}, [props.values?.firmAdminCanEnableEmail]);

  return (
    <>
      {(props.action === ACTIONS.ADD ||
        props.action === ACTIONS.EDIT ||
        props.editConfigurationSetting) && (
        <div className="tab-section">
          <section className="sectionA">
            <p
              style={{
                fontSize: "22px",
                fontWeight: "600",
                padding: "0px 0px",
              }}
            >
              {t("hospital.settings")}
            </p>
          </section>
    
          {showStudyLinkSettings && (
            <>
              <div style={{ display: "flex", maxHeight: "60px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key">
                    {t("hospital.study-link-validity-time")}
                  </p>
                </div>
                <div
                  className="ms-Grid-col ms-sm6 ms-lg4 ms-xl4 single-line-form-field-value"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div style={{ marginLeft: "5px" , marginbottom: "10px"}}>
                    <TextField
                      type="number"
                      name="studyLinkExpiryTime"
                      placeholder={t("hospital.study-link-validity-time")}
                      value={props.values.studyLinkExpiryTime ?? ""}
                      onBlur={props.handleBlur}
                      onChange={props.handleChange}
                      errorMessage={
                        (props.errorState?.studyLinkExpiryTime?.error &&
                          props.errorState?.studyLinkExpiryTime?.msg) ||
                        props.firmGlobalErrorState?.studyLinkExpiryTime
                      }
                    />
                  </div>
                </div>
              </div>
              </>
          )}

          {showReportLinkSettings && (
            <>
              {/* 2. Enable Share Report Link */}
              <div
                style={{
                  display: "flex",
                  maxHeight: "40px",
                  marginBottom:"10px",
                }}
              >
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key" style={{marginTop:"10px"}}>
                    {t("hospital.enable-share-report-link")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div style={{ marginTop: "5px" }}>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.enableShareReportLink}
                      onChangeCustom={() => {
                        const newValue = !props.values.enableShareReportLink;
                        setEnableShareReportLink(newValue);
                        if (props.setFieldValue) {
                          props.setFieldValue("enableShareReportLink", newValue);
                        }
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* 3. Report Link Validity Time (in Hours) */}
              {enableShareReportLink && (
                <div style={{ display: "flex", maxHeight: "60px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <p className="single-line-form-field-key">
                      {t("hospital.report-link-validity-time")}
                    </p>
                  </div>
                  <div
                    className="ms-Grid-col ms-sm6 ms-lg4 ms-xl4 single-line-form-field-value"
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ marginLeft: "5px" ,marginBottom:"10px"}}>
                      <TextField
                        type="number"
                        name="reportLinkExpiryTime"
                        placeholder={t("hospital.report-link-validity-time")}
                        value={props.values.reportLinkExpiryTime}
                        onBlur={props.handleBlur}
                        onChange={props.handleChange}
                        errorMessage={
                          (props.errorState?.reportLinkExpiryTime?.error &&
                            props.errorState?.reportLinkExpiryTime?.msg) ||
                          props.firmGlobalErrorState?.reportLinkExpiryTime
                        }
                      />
                    </div>
                  </div>
                </div>
              )}
           </>
          )}
          {/* ENABLE SHOW PRIORS LINK IN REPORT */}
          {((props.roles[0] === USERTYPES.ADMIN &&
            props.action === ACTIONS.ADD) ||
            (props.roles[0] === USERTYPES.FIRMADMIN &&
              ((props.action === ACTIONS.EDIT && props.ownFirm) ||
                props.action === ACTIONS.ADD))) && (
            <>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <p className="single-line-form-field-key">
                      {t("hospital.show-priors-studies")}
                    </p>
                  </div>
                  <div id="show-priors-studies-checkbox" className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <CustomCheckBox
                        parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                        values={props.values.showPriorsStudies}
                        onChangeCustom={() => {
                          props.values.showPriorsStudies =
                            !props.values.showPriorsStudies;
                        }}
                      />
                  </div>
                </div>
              </div>
            </>
          )}

          {/* ENABLE ADDENDUM WORKFLOW */}
          {((props.roles[0] === USERTYPES.ADMIN &&
            (props.action === ACTIONS.ADD || props.action === ACTIONS.EDIT)) ||
            (props.roles[0] === USERTYPES.FIRMADMIN &&
              props.action === ACTIONS.ADD) ||
            (props.roles[0] === USERTYPES.FIRMADMIN &&
              props.ownFirm &&
              props.action === ACTIONS.EDIT)) && (
            <>
              <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key">
                    {t("hospital.enable-addendum-workflow")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.addendumWorkflowEnabled}
                      onChangeCustom={() => {
                        props.values.addendumWorkflowEnabled =
                          !props.values.addendumWorkflowEnabled;
                      }}
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {/* SHOW AI RESULTS SAVED REPORT FOR FIRM DOCTORS */}
          {((props.roles[0] === USERTYPES.ADMIN &&
            (props.action === ACTIONS.ADD || props.action === ACTIONS.EDIT)) ||
            (props.roles[0] === USERTYPES.FIRMADMIN &&
              props.action === ACTIONS.ADD) ||
            (props.roles[0] === USERTYPES.FIRMADMIN &&
              props.ownFirm &&
              props.action === ACTIONS.EDIT)) && (
            <>
              <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key">
                    {t("hospital.show-ai-results-saved-report-firm-doctors")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.showAiResultsSavedReportForFirmDoctors}
                      onChangeCustom={() => {
                        props.values.showAiResultsSavedReportForFirmDoctors =
                          !props.values.showAiResultsSavedReportForFirmDoctors;
                      }}
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {/* SPLIT MULTI-FRAME DICOMS AT UPLOAD */}
          {((props.roles[0] === USERTYPES.ADMIN &&
            (props.action === ACTIONS.ADD || props.action === ACTIONS.EDIT)) ||
            (props.roles[0] === USERTYPES.FIRMADMIN &&
              props.action === ACTIONS.ADD) ||
            (props.roles[0] === USERTYPES.FIRMADMIN &&
              props.ownFirm &&
              props.action === ACTIONS.EDIT)) && (
            <>
              <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key">
                    {t("hospital.split-multiframe-dicoms")}
                  </p>
                </div>
                <div id="multiframe-split-checkbox" className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.multiframeSplit}
                      onChangeCustom={() => {
                        props.values.multiframeSplit =
                          !props.values.multiframeSplit;
                      }}
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {/* SEND REPORT SUBMIT NOTIFICATION */}
          {(props.roles[0] === USERTYPES.ADMIN ||
            (props.roles[0] === USERTYPES.FIRMADMIN && props.ownFirm)) && (
            <>
              <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key">
                    {t("hospital.enable-send-report-submit-notification")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.sendReportSubmitNotification}
                      onChangeCustom={() => {
                        props.values.sendReportSubmitNotification =
                          !props.values.sendReportSubmitNotification;
                      }}
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {showCriticalAlertSetting && (
            <>
              <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key">
                    {t("hospital.enable-critical-alert")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.enableCriticalAlert}
                      onChangeCustom={() => {
                        props.values.enableCriticalAlert =
                          !props.values.enableCriticalAlert;
                      }}
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {/* AI Draft Report: per-hospital switch and AI service profile (super admin, existing firm) */}
          {props.roles[0] === USERTYPES.ADMIN &&
            (props.action === ACTIONS.EDIT || props.action === ACTIONS.VIEW) &&
            props.values?.id && (
              <AiDraftSiteSettings firmId={props.values.id} readOnly={props.action === ACTIONS.VIEW} />
            )}


          {/* ENABLE ADDENDUM DISCLAIMER */}
          {/* {(props.roles[0] === USERTYPES.ADMIN ||
            props.roles[0] === USERTYPES.FIRMTECHNICIAN) && (
            <>
              <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key">
                    {t("hospital.enable-addendum-disclaimer")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.addendumDisclaimerEnabled}
                      onChangeCustom={() => {
                        setEnableAddendumDisclaimerText(
                          !enableAddendumDisclaimerText
                        );
                        props.values.addendumDisclaimerEnabled =
                          !props.values.addendumDisclaimerEnabled;
                      }}
                    />
                  </div>
                </div>
              </div>
              {enableAddendumDisclaimerText && (
                <div style={{ display: "flex" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <p className="single-line-form-field-key">
                      {t("hospital.addendum-disclaimer-text")}
                    </p>
                  </div>
                  <div
                    className="ms-Grid-col ms-sm12 ms-lg6 ms-xl6 single-line-form-field-value"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "5px",
                    }}
                  >
                    <TextField
                      styles={{
                        root: {
                          width: "100%",
                        },
                      }}
                      name="addendumDisclaimerText"
                      placeholder={t("hospital.addendum-disclaimer-text")}
                      value={props.values.addendumDisclaimerText}
                      onBlur={props.handleBlur}
                      onChange={(e) => props.handleChange(e)}
                      resizable
                      multiline
                      errorMessage={
                        props.errorState?.addendumDisclaimerText?.error &&
                        props.errorState?.addendumDisclaimerText?.msg
                      }
                    />
                  </div>
                </div>
              )}
            </>
          )} */}

          {/* ENABLE DOWNLOAD STUDY */}
          {props.roles[0] === USERTYPES.ADMIN && (
            <>
              <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key">
                    {t("hospital.enable-download-study")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.allowDownloadStudy}
                      onChangeCustom={() => {
                        props.values.allowDownloadStudy =
                          !props.values.allowDownloadStudy;
                      }}
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {/* ENABLE DOWNLOAD REPORT */}
          {props.roles[0] === USERTYPES.ADMIN && (
            <>
              <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key">
                    {t("hospital.enable-download-report")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.allowDownloadReport}
                      onChangeCustom={() => {
                        props.values.allowDownloadReport =
                          !props.values.allowDownloadReport;
                      }}
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {/* ENABLE QR CODE IN REPORT */}
          {/* {(props.roles[0] === USERTYPES.ADMIN ||
            props.roles[0] === USERTYPES.FIRMTECHNICIAN) && (
            <>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <p className="single-line-form-field-key">
                      {t("hospital.enable-qr-code")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div>
                      <CustomCheckBox
                        parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                        values={props.values.enableQRCodeInReport}
                        onChangeCustom={() => {
                          props.values.enableQRCodeInReport =
                            !props.values.enableQRCodeInReport;
                        }}
                      />
                    </div>
                  </div>
                </div>
                
                <div style={{ marginLeft: "5px" }}>
            <p
              style={{
                fontSize: 13,
                color: themeName === "light" ? "#808080" : "#bebebe",
              }}
            >
              {t("hospital.qr-code-link-expity-msg")}
            </p>
          </div>
              </div>
            </>
          )} */}


          {/* ENABLE UNASSIGNMENT SERVICE  */}
          {/* {(props.action === ACTIONS.EDIT &&
            props.roles[0] === USERTYPES.FIRMADMIN &&
            !props.ownFirm) ||
            (props.action === ACTIONS.ADD &&
              props.roles[0] === USERTYPES.FIRMADMIN) && (
            <>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <p className="single-line-form-field-key">
                      {t("hospital.enable-unassignment-service")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div>
                      <CustomCheckBox
                        parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                        values={props.values.enableUnassignmentService}
                        onChangeCustom={() => {
                          props.values.enableUnassignmentService =
                            !props.values.enableUnassignmentService;
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )} */}
          {/* ENABLE UNASSIGNMENT SERVICE  */}
          {(props.action === ACTIONS.EDIT &&
            props.roles[0] === USERTYPES.FIRMADMIN &&
            !props.ownFirm) ||
            (props.action === ACTIONS.ADD &&
              props.roles[0] === USERTYPES.FIRMADMIN) && (
            <>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <p className="single-line-form-field-key">
                      {t("hospital.enable-unassignment-service")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div>
                      <CustomCheckBox
                        parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                        values={props.values.enableUnassignmentService}
                        onChangeCustom={() => {
                          const newValue = !props.values.enableUnassignmentService;
                          props.values.enableUnassignmentService = newValue;
                          setEnableUnassignmentService(newValue);
                          props.setFieldValue?.("enableUnassignmentService", newValue);
                          if (!newValue) {
                            setSelectedUnassignmentModality([]);
                            props.values.unassignmentModalityIds = [];
                            props.setFieldValue?.("unassignmentModalityIds", []);
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Modality Dropdown for Unassignment - appears only when enabled */}
              {props.values.enableUnassignmentService && (
                <div style={{ display: "flex", maxHeight: "60px", marginTop: "5px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <p className="single-line-form-field-key">
                      {t("hospital.selected-modality-for-unassignment")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4 single-line-form-field-value">
                    <div
                      style={{
                        paddingLeft: "8px",
                        marginTop: "5px",
                        display: "flex",
                        alignItems: "center",
                        height: "100%",
                        width: "100%",
                      }}
                    >
                      <ComboBox
                        selectedKey={selectedUnassignmentModality}
                        placeholder={t("hospital.select-modality")}
                        options={[...modalityList]}
                        multiSelect
                        calloutProps={{ doNotLayer: true }}
                        onChange={(e, option) => {
                          let selected = option?.selected;
                          if (option) {
                            setSelectedUnassignmentModality((prevSelectedKeys) => {
                              const newSelection = selected
                                ? [...prevSelectedKeys, option.key]
                                : prevSelectedKeys.filter((k) => k !== option.key);
                              return newSelection;
                            });
                          }
                        }}
                        errorMessage={
                          (props.errorState?.unassignmentModalityIds?.error &&
                            props.errorState.unassignmentModalityIds.msg) ||
                          props.errorState?.otherSettings?.unassignmentModalityIds?.msg
                        }
                      />
                    </div>
                  </div>
                </div>
              )}
            </>
          )}

          {(props.action === ACTIONS.EDIT &&
            props.roles[0] === USERTYPES.FIRMADMIN &&
            !props.ownFirm) ||
            (props.action === ACTIONS.ADD &&
              props.roles[0] === USERTYPES.FIRMADMIN && (
                <>
                  {/* AUTO ASSIGNMENT ENABLE */}
                  {/* <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <p className="single-line-form-field-key">
                        {t("hospital.enable-auto-assignment")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.autoAssignEnable}
                          onChangeCustom={() => {
                            setAutoAssignEnabled((prev) => !prev);
                            props.values.autoAssignEnable =
                              !props.values.autoAssignEnable;
                          }}
                        />
                      </div>
                    </div>
                  </div> */}

                  {/* {autoAssignEnabled && (
                    <div style={{ display: "flex", maxHeight: "60px" }}>
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                        <p className="single-line-form-field-key">
                          {t("hospital.modality")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4 single-line-form-field-value">
                        <div
                          style={{
                            paddingLeft: "8px",
                            marginTop: "5px",
                            display: "flex",
                            alignItems: "center",
                            height: "100%",
                            width: "100%",
                          }}
                        >
                          <ComboBox
                            selectedKey={selectedAutoAssignModality}
                            placeholder="Select Modality"
                            options={[
                              {
                                key: "selectAll",
                                text: "Select All",
                                itemType:
                                  SelectableOptionMenuItemType.SelectAll,
                              },
                              ...modalityList,
                            ]}
                            multiSelect
                            calloutProps={{ doNotLayer: true }}
                            onChange={(e, option) => {
                              const selected = option?.selected;
                              const currentSelectedOptionKeys =
                                selectedAutoAssignModality.filter(
                                  (key) => key !== "selectAll"
                                );
                              const selectAllState =
                                currentSelectedOptionKeys.length ===
                                modalityList.length;

                              if (option) {
                                if (option?.key === "selectAll") {
                                  selectAllState
                                    ? setSelectedAutoAssignModality([])
                                    : setSelectedAutoAssignModality([
                                        "selectAll",
                                        ...modalityList.map((o) => o.key),
                                      ]);
                                } else {
                                  const updatedKeys = selected
                                    ? [...currentSelectedOptionKeys, option.key]
                                    : currentSelectedOptionKeys.filter(
                                        (k) => k !== option.key
                                      );
                                  if (
                                    updatedKeys.length === modalityList.length
                                  ) {
                                    // updatedKeys.push('selectAll');
                                  }
                                  setSelectedAutoAssignModality(updatedKeys);
                                }
                              }
                            }}
                            errorMessage={
                              props.errorState?.autoAssignModalityIds?.error &&
                              props.errorState?.autoAssignModalityIds?.msg
                            }
                          />
                        </div>
                      </div>
                    </div>
                  )} */}

                  {/* ENABLE PRINT DISCLAIMER */}
                  <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px", marginTop: "5px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <p className="single-line-form-field-key">
                        {t("hospital.enable-print-disclaimer")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.addPrintDisclaimer}
                          onChangeCustom={() => {
                            setEnablePrintDisclaimerText(
                              !enablePrintDisclaimerText
                            );
                            props.values.addPrintDisclaimer =
                              !props.values.addPrintDisclaimer;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {enablePrintDisclaimerText && (
                    <div style={{ display: "flex" }}>
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                        <p className="single-line-form-field-key">
                          {t("hospital.print-disclaimer-text")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg6 ms-xl6 single-line-form-field-value">
                        <div
                          style={{
                            marginTop: "5px",
                            marginLeft: "5px",
                          }}
                        >
                          <TextField
                            styles={{
                              root: {
                                width: "100%",
                              },
                            }}
                            name="printDisclaimerText"
                            placeholder={t("hospital.print-disclaimer-text")}
                            value={props.values.printDisclaimerText}
                            onBlur={props.handleBlur}
                            onChange={(e) => props.handleChange(e)}
                            resizable
                            multiline
                            errorMessage={
                              props.errorState?.printDisclaimerText?.error &&
                              props.errorState?.printDisclaimerText?.msg
                            }
                          />
                        </div>
                      </div>
                    </div>
              )}
              

              {/* ENABLE MS WORD */}
          {/* {(props.action === ACTIONS.ADD && ((props.roles[0] === USERTYPES.ADMIN) || (props.roles[0] === USERTYPES.FIRMADMIN)))  && (
            <>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <p className="single-line-form-field-key">
                      {t("hospital.enable-ms-word")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div>
                      <CustomCheckBox
                        parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                        values={props.values.showWord}
                        onChangeCustom={() => {
                          props.values.showWord =
                            !props.values.showWord;
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )} */}

                  {/* ENTER ACCOUNT WARNING */}
                  <div style={{ display: "flex" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <p className="single-line-form-field-key">
                        {t("hospital.account-warning")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "10px", marginLeft: "5px" }}>
                        <TextField
                          name="accountWarning"
                          placeholder={t("hospital.account-warning")}
                          onChange={(e) => {
                            props.handleChange(e);
                          }}
                          value={props.values.accountWarning}
                          resizable
                          multiline
                          errorMessage={
                            props.errorState?.accountWarning?.error &&
                            props.errorState?.accountWarning?.msg
                          }
                          // disabled={!isOtherReason}
                        />
                      </div>
                    </div>
                  </div>

                  {/* MAX PRIORITY COUNT */}
                  <div style={{ display: "flex" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <p className="single-line-form-field-key">
                        {t("hospital.max-priority-count")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "10px", marginLeft: "5px" }}>
                        <TextField
                          name="priorityCount"
                          type="number"
                          resizable={false}
                          value={props.values.priorityCount}
                          onBlur={props.handleBlur}
                          onChange={(e) => {
                            props.handleChange(e);
                          }}
                          errorMessage={
                            props.errorState?.priorityCount?.error &&
                            props.errorState?.priorityCount?.msg
                          }
                        />
                      </div>
                    </div>
                  </div>

                  {/* QUALITY CHECK ENABLED */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      minHeight: "40px",
                      marginBottom: "0px",
                      marginTop: "5px",
                    }}
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <p className="single-line-form-field-key">
                        {t("hospital.enable-quality-check")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.qcEnabled || props.values.preliminaryQcEnabled}
                          onChangeCustom={() => {
                            const newValue = !(
                              props.values.qcEnabled ||
                              props.values.preliminaryQcEnabled
                            );
                            setQcEnabled(newValue);
                            if (!newValue) {
                              props.values.qcEnabled = false;
                              props.values.preliminaryQcEnabled = false;
                              setPreliminaryQcEnabled(false);
                              props.values.twoSignaturesAllowed = false;
                              props.values.enableQCAutoAssignment = false;
                            } else {
                              props.values.qcEnabled = true;
                              props.values.preliminaryQcEnabled = false;
                              setPreliminaryQcEnabled(false);
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
          {qcEnabled && (
            <>
              <div
                style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px", marginTop: "5px" }}
              >
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key">
                    {t("hospital.qc-type")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div
                    style={{ marginTop: "5px" }}
                    className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg8 ms-xl12"
                  >
                    <ChoiceGroup
                      options={[
                        { key: "final", text: t("hospital.final-qc") },
                        { key: "preliminary", text: t("hospital.preliminary-qc") },
                      ]}
                      selectedKey={
                        preliminaryQcEnabled ? "preliminary" : "final"
                      }
                      onChange={(ev, option) => {
                        if (option?.key === "preliminary") {
                          props.values.qcEnabled = false;
                          props.values.preliminaryQcEnabled = true;
                          setPreliminaryQcEnabled(true);
                        } else {
                          props.values.qcEnabled = true;
                          props.values.preliminaryQcEnabled = false;
                          setPreliminaryQcEnabled(false);
                        }
                      }}
                      styles={{
                        flexContainer: { display: "flex", gap: "20px" },
                      }}
                    />
                  </div>
                </div>
              </div>
              <div
                style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px", marginTop: "5px" }}
              >
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key">
                    {t("hospital.allow-two-signatures")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.twoSignaturesAllowed}
                      onChangeCustom={() => {
                        props.values.twoSignaturesAllowed =
                          !props.values.twoSignaturesAllowed;
                      }}
                    />
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", maxHeight: "60px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key">
                    {t("hospital.modality")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4 single-line-form-field-value">
                  <div
                    style={{
                      paddingLeft: "8px",
                      marginTop: "5px",
                      display: "flex",
                      alignItems: "center",
                      height: "100%",
                      width: "100%",
                    }}
                  >
                    <ComboBox
                      selectedKey={selectedModality}
                      placeholder="Select Modality"
                      options={[...modalityList]}
                      multiSelect
                      calloutProps={{ doNotLayer: true }}
                      onChange={(e, option) => {
                        let selected = option?.selected;
                        if (option) {
                          setSelectedModality((prevSelectedKeys) =>
                            selected
                              ? [...prevSelectedKeys, option.key]
                              : prevSelectedKeys.filter((k) => k !== option.key)
                          );
                        }
                      }}
                      errorMessage={
                        props.errorState?.modalityIds?.error &&
                        props.errorState?.modalityIds?.msg
                      }
                    />
                  </div>
                </div>
              </div>
              <div
                style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px", marginTop: "5px" }}
              >
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key">
                    {t("hospital.enable-qc-auto-assignment")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.enableQCAutoAssignment}
                      onChangeCustom={() => {
                        props.values.enableQCAutoAssignment =
                          !props.values.enableQCAutoAssignment;
                      }}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        {/* History available settings */}
          <div style={{
                      display: "flex",
                      alignItems: "center",
                      minHeight: "40px",
                      marginBottom: "0px",
                      marginTop: "5px",
                    }}>
                          <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                            <p className="single-line-form-field-key">
                              {t("hospital.history-available")}
                            </p>
                          </div>
                          <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                            <div>
                              <CustomCheckBox
                                parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                                values={props.values.historyAvailable}
                                onChangeCustom={() => {
                                  // setHistoryAvailable((prev) => !prev);
                                  // props.values.historyAvailable = !props.values.historyAvailable;
                                  const newValue = !props.values.historyAvailable;
                                  console.log("new Value", newValue);
                                  setHistoryAvailable(newValue);
                                  props.values.historyAvailable = newValue;
          
                                  if (!newValue) {
                                    props.values.clinicalNoteMandatory = false;
                                    props.values.subModalityMandatory = false;
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        {historyAvailable && (
                          <>
                            <div style={{ display: "flex", maxHeight: "60px" }}>
                              <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                                <p className="single-line-form-field-key">
                                  {t("hospital.modality")}
                                </p>
                              </div>
                              <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4 single-line-form-field-value">
                                <div
                                  style={{
                                    paddingLeft: "8px",
                                    marginTop: "5px",
                                    display: "flex",
                                    alignItems: "center",
                                    height: "100%",
                                    width: "100%",
                                  }}
                                >
                                  <ComboBox
                                    selectedKey={selectedHistoryModality}
                                    placeholder="Select Modality"
                                    options={[...historyModalityList]}
                                    multiSelect
                                    calloutProps={{ doNotLayer: true }}
                                    onChange={(e, option) => {
                                      let selected = option?.selected;
                                      if (option) {
                                        setSelectedHistoryModality((prevSelectedKeys) =>
                                          selected
                                            ? [...prevSelectedKeys, option.key]
                                            : prevSelectedKeys.filter(
                                                (k) => k !== option.key
                                              )
                                        );
                                      }
                                    }}
                                    errorMessage={
                                      props.errorState?.historyModalityIds?.error &&
                                      props.errorState?.historyModalityIds?.msg
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        )}
          
          {historyAvailable && (
                          <>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                minHeight: "40px",
                                marginBottom: "0px",
                              }}
                            >
                              <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                                <p className="single-line-form-field-key">
                                  {t("hospital.clinical-note-mandatory")}
                                </p>
                              </div>
                              <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                                <div>
                                  <CustomCheckBox
                                    parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                                    values={props.values.clinicalNoteMandatory}
                                    onChangeCustom={() => {
                                      props.values.clinicalNoteMandatory =
                                        !props.values.clinicalNoteMandatory;
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        )}
          
          {historyAvailable && !isVdcPlatform && (
                          <>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                minHeight: "40px",
                                marginBottom: "0px",
                              }}
                            >
                              <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                                <p className="single-line-form-field-key">
                                  {t("hospital.sub-modality-mandatory")}
                                </p>
                              </div>
                              <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                                <div>
                                  <CustomCheckBox
                                    parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                                    values={props.values.subModalityMandatory}
                                    onChangeCustom={() => {
                                      props.values.subModalityMandatory =
                                        !props.values.subModalityMandatory;
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        )}
          {/* Technician contact mandatory */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      minHeight: "40px",
                      marginBottom: "0px",
                      marginTop: "5px",
                    }}
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <p className="single-line-form-field-key">
                        {t("hospital.technician-contact-mandatory")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.technicianContactMandatory}
                          onChangeCustom={() => {
                            setTechnicianContactMandatory((prev) => !prev);
                            props.values.technicianContactMandatory = !props.values.technicianContactMandatory;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  
                </>
              ))}
          

          {props.roles[0] === USERTYPES.FIRMADMIN && (
              <>
                <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <p className="single-line-form-field-key">
                      {t("hospital.sub_modality_list_number")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div style={{ marginTop: "10px", marginLeft: "5px" }}>
                      <Dropdown
                        selectedKey={props.values.selectedSubModalityListNumber}
                        placeholder="Select Sub Modality List Number"
                        options={[...subModalityListNumbers]}
                        calloutProps={{ doNotLayer: true }}
                        onChange={(e, option) => {
                          props.values.selectedSubModalityListNumber =
                            option.key;
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    maxHeight: "70px",
                    marginTop: "5px",
                  }}
                >
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <p className="single-line-form-field-key">
                      {t("hospital.branch-code")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div style={{ marginTop: "10px", marginLeft: "5px" }}>
                      <TextField
                        name="branchCode"
                        onChange={(e) => {
                          props.handleChange(e);
                        }}
                        errorMessage={props.firmGlobalErrorState?.branchCode}
                        value={props.values.branchCode}
                        onBlur={props.handleBlur}
                        resizable={false}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}

           { (props.roles[0] === USERTYPES.ADMIN && (!props.isMinimalAccount || props.isMinimalAccount === "false") && isEnableWhatsApp ) && (  // only Super Admin / Admin can see this (adjust role check as needed)
            <>
              <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key">
                    {/* Can your firm admin be allowed to set the minimal clients communication mode */}
                    Allow firm admin to set client communication
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={allowFirmAdminSetClientComm}
                      onChangeCustom={() => {
                        const newVal = !allowFirmAdminSetClientComm;
                        setAllowFirmAdminSetClientComm(newVal);
                        props.values.allowFirmAdminSetClientComm = newVal;
                        console.log('UI toggle allowFirmAdminSetClientComm ->', newVal, 'props.values.allowFirmAdminSetClientComm ->', props.values.allowFirmAdminSetClientComm);

                        // if disabling master, also clear sub-flags (optional)
                        if (!newVal) {
                          setFirmAdminCanEnableWhatsapp(false);
                          setFirmAdminCanEnableEmail(false); // keep email true by default if you want
                          props.values.firmAdminCanEnableWhatsapp = false;
                          props.values.firmAdminCanEnableEmail = false;
                        } else {
                          setFirmAdminCanEnableEmail(true);
                          setFirmAdminCanEnableWhatsapp(false);
                          props.values.firmAdminCanEnableEmail = true;
                          props.values.firmAdminCanEnableWhatsapp = false;
                        }
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* show the two sub flags only when master is checked */}
              {allowFirmAdminSetClientComm && (
                <>
                  <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px", marginLeft: "12px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <p className="single-line-form-field-key">Allow firm admin to enable WhatsApp?</p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <CustomCheckBox
                          values={firmAdminCanEnableWhatsapp}
                          onChangeCustom={() => {
                            const newVal = !firmAdminCanEnableWhatsapp;
                            setFirmAdminCanEnableWhatsapp(newVal);
                            props.values.firmAdminCanEnableWhatsapp = newVal;
                              console.log('UI toggle firmAdminCanEnableWhatsapp ->', newVal, 'props.values.firmAdminCanEnableWhatsapp ->', props.values.firmAdminCanEnableWhatsapp);

                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px", marginLeft: "12px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <p className="single-line-form-field-key">Allow firm admin to enable Email?</p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <CustomCheckBox
                          values={firmAdminCanEnableEmail}
                          onChangeCustom={() => {
                            const newVal = !firmAdminCanEnableEmail;
                            setFirmAdminCanEnableEmail(newVal);
                            props.values.firmAdminCanEnableEmail = newVal;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {props.errorState?.masterClientComm?.error && (
                  <div style={{ color: "red", marginLeft: "8px", marginTop: "6px" , fontWeight:"600" }}>
                    {props.errorState.masterClientComm.msg}
                  </div>
)}

                </>
              )}
            </>
          )}

          <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px" }}>
            <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
              <p className="single-line-form-field-key">
                {t("account-and-settings.timezone") || "Time Zone"}
              </p>
            </div>
            <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
              <Select
                classNamePrefix="react-select"
                options={timeZoneOptions}
                value={timeZoneOptions.find(
                  tz => tz.value === effectiveTimeZone
                )}
                isSearchable
                onChange={(item) => {
                  props.setFieldValue("firmTimeZone", item?.value ?? null);
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    width: "100%",
                    color: getThemeColor("primary-color"),
                    backgroundColor: getThemeColor("action-details-background"),
                    border: getThemeColor("border"),
                  }),
                  menu: (base) => ({
                    ...base,
                    backgroundColor: getThemeColor("action-details-background"),
                  }),
                  option: (base, state) => ({
                    ...base,
                    color: getThemeColor("primary-color"),
                    backgroundColor: state.isFocused
                      ? getThemeColor("popup-hover")
                      : getThemeColor("action-details-background"),
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: getThemeColor("primary-color"),
                  }),
                  input: (base) => ({
                    ...base,
                    color: getThemeColor("primary-color"),
                  }),
                }}
              />
            </div>
          </div>
          <div style={{ marginLeft: "5px" }}>
            <p
              style={{
                fontSize: 13,
                color: themeName === "light" ? "#808080" : "#bebebe",
              }}
            >
              {t("account-and-settings.timezone-note-firm")}
            </p>
          </div>

          {isBucketManagement && (props.roles[0] === USERTYPES.ADMIN || props.roles[0] === USERTYPES.FIRMADMIN) && props.formik && (
            <fieldset className="border rounded p-4 fieldset-bucket-config">
              <legend className="font-bold">Bucket Configurations</legend>
              
              <FormikProvider value={props.formik}>
                <FieldArray name="modalityBuckets">
                  {({ push, remove }) => (
                    <div>
                      {(props.values.modalityBuckets || []).map((item, idx) => {
                        // Get all selected modalities except current one
                        const selectedModalities = props.values.modalityBuckets
                          .map((m, i) => (i !== idx ? m.modality : null))
                          .filter(Boolean);

                        // Filter available list for this row
                        const availableModalities = bucketModalityList.filter(
                          option => !selectedModalities.includes(option.key)
                        );

                        return (
                          <div
                            key={idx}
                            style={{ display: "flex", marginBottom: 8, alignItems: "center" }}
                          >
                            <Dropdown
                              placeholder="Select Modality"
                              options={availableModalities}
                              selectedKey={item.modality}
                              onChange={(e, option) =>
                                props.setFieldValue(`modalityBuckets.${idx}.modality`, option.key)
                              }
                              style={{ width: 200, marginRight: 8 }}
                              errorMessage={getIn(
                                props.errors,
                                `modalityBuckets.${idx}.modality`
                              )}
                            />

                            <Dropdown
                              placeholder="Select Bucket"
                              options={bucketOptions}
                              selectedKey={item.bucketConfiguration}
                              onChange={(e, option) =>
                                props.setFieldValue(
                                  `modalityBuckets.${idx}.bucketConfiguration`,
                                  option.key
                                )
                              }
                              style={{ width: 200, marginRight: 8 }}
                              // errorMessage={props.errorState?.modalityBuckets?.msg}
                            />
                            {item.modality !== "DEFAULT" && (
                              <IconButton
                                iconProps={{ iconName: "Delete" }}
                                onClick={() => remove(idx)}
                                disabled={props.values.modalityBuckets.length === 1}
                                title="Delete"
                                ariaLabel="Delete"
                                style={{ marginRight: 8 }}
                              />
                            )}

                            {props.values.modalityBuckets.length < bucketModalityList.length &&
                             idx === props.values.modalityBuckets.length - 1 && (
                              <PrimaryButton
                                iconProps={{ iconName: "Add" }}
                                text=""
                                ariaLabel="Add"
                                onClick={() =>
                                  push({ modality: "", bucketConfiguration: "" })
                                }
                              />
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </FieldArray>
              </FormikProvider>
              {typeof props.errorState?.modalityBuckets?.msg === "string" && (
                <div style={{ color: "red", marginTop: "10px" }}>
                  {props.errorState?.modalityBuckets?.msg}
                </div>
              )}
            
            </fieldset>
          )}
          {/* --- MASTER FLAG: Allow firm admin to set client comm mode --- */}
         

        </div>
      )}
      {props.action === ACTIONS.VIEW && !props.editConfigurationSetting && (
        <div className="tab-section">
          <section className="sectionA" style={{ marginBottom: "1rem" }}>
            <p
              style={{
                fontSize: "22px",
                fontWeight: "600",
                padding: "0px 0px",
              }}
            >
              {t("hospital.settings")}
            </p>
          </section>
          <div className="ms-Grid" dir="ltr">

            

            {/* ADDENDUM DISCLAIMER */}
            {/* {(props.roles[0] === USERTYPES.ADMIN ||
              props.roles[0] === USERTYPES.FIRMDOCTOR ||
              props.roles[0] === USERTYPES.FIRMTECHNICIAN ||
              (props.ownFirm && props.roles[0] === USERTYPES.FIRMADMIN)) && (
              <>
                <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <div className="form-heading">
                      {t("hospital.enable-addendum-disclaimer")}
                    </div>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                    <div>
                      {props.values.addendumDisclaimerEnabled ? "Yes" : "No"}
                    </div>
                  </div>
                </div>
                {!!enableAddendumDisclaimerText && (
                  <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                      <div className="form-heading">
                        {t("hospital.addendum-disclaimer-text")}
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                      <div>
                        {props.values.addendumDisclaimerText
                          ? props.values.addendumDisclaimerText
                          : ""}
                      </div>
                    </div>
                  </div>
                )}
              </>
            )} */}

            {/* ENABLE DOWNLOAD STUDY */}
            {props.roles[0] === USERTYPES.ADMIN && (
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.enable-download-study")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>{props.values.allowDownloadStudy ? "Yes" : "No"}</div>
                </div>
              </div>
            )}

            {/* Enable Download Report - View */}
            {props.roles[0] === USERTYPES.ADMIN && (
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.enable-download-report")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>{props.values.allowDownloadReport ? "Yes" : "No"}</div>
                </div>
              </div>
            )}


        {showStudyLinkSettings && (
          <>
            {/* Study Link Expiry Time - View */}
            <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                <div className="form-heading">
                  {t("hospital.study-link-validity-time")}
                </div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                <div>
                  {props.values.studyLinkExpiryTime ? props.values.studyLinkExpiryTime : "0"}
                </div>
              </div>
            </div>
             </>
        )}
        {showReportLinkSettings && (
          <>
            {/* Enable Share Report Link - View */}
            <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                <div className="form-heading">
                  {t("hospital.enable-share-report-link")}
                </div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                <div>
                  {props.values.enableShareReportLink ? "Yes" : "No"}
                </div>
              </div>
            </div>

            {/* Report Link Validity Time - View (conditional) */}
            {props.values.enableShareReportLink && (
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.report-link-validity-time")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>
                    {props.values.reportLinkExpiryTime ? props.values.reportLinkExpiryTime : "0"}
                  </div>
                </div>
              </div>
            )}
         </>
        )}

            {/* ENABLE ADDENDUM WORKFLOW - View */}
            {(props.roles[0] === USERTYPES.ADMIN ||
              (props.roles[0] === USERTYPES.FIRMADMIN && props.ownFirm)) && (
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.enable-addendum-workflow")}
                  </div>
                </div>
                <div id="enable-addendum-workflow-value" className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>{props.values.addendumWorkflowEnabled ? "Yes" : "No"}</div>
                </div>
              </div>
            )}

{/* SHOW AI RESULTS SAVED REPORT FOR FIRM DOCTORS - View */}
            {(props.roles[0] === USERTYPES.ADMIN ||
              (props.roles[0] === USERTYPES.FIRMADMIN && props.ownFirm)) && (
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.show-ai-results-saved-report-firm-doctors")}
                  </div>
                </div>
                <div id="show-ai-results-saved-report-firm-doctors-value" className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>{props.values.showAiResultsSavedReportForFirmDoctors ? "Yes" : "No"}</div>
                </div>
              </div>
            )}

            {/* SPLIT MULTI-FRAME DICOMS AT UPLOAD - View */}
            {(props.roles[0] === USERTYPES.ADMIN ||
              (props.roles[0] === USERTYPES.FIRMADMIN && props.ownFirm)) && (
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.split-multiframe-dicoms")}
                  </div>
                </div>
                <div id="multiframe-split-value" className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>{props.values.multiframeSplit ? "Yes" : "No"}</div>
                </div>
              </div>
            )}
            {/* Send Report Submit Notification - View */}
            {(props.roles[0] === USERTYPES.ADMIN ||
              (props.roles[0] === USERTYPES.FIRMADMIN && props.ownFirm)) && (
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.enable-send-report-submit-notification")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>{props.values.sendReportSubmitNotification ? "Yes" : "No"}</div>
                </div>
              </div>
            )}

            {/* NEW (Raise Alert feature): Enable Critical Alert - View.
                Hidden for a minimal client for the same reason as the edit row: its own
                column is never read, so showing Yes/No from it would state the opposite
                of what the study will actually do. */}
            {showCriticalAlertSetting && (
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.enable-critical-alert")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>{props.values.enableCriticalAlert ? "Yes" : "No"}</div>
                </div>
              </div>
            )}

            {props.roles[0] === USERTYPES.ADMIN || props.roles[0] === USERTYPES.FIRMADMIN &&(
            <div className="ms-Grid-row" style={{ minHeight: "40px", marginBottom: "12px" }}>
                            <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                              <div className="form-heading">
                                {t("hospital.enable-show-priors-studies")}
                              </div>
                            </div>
                            <div id="show-priors-studies-value" className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                              <div>{props.values.showPriorsStudies ? "Yes" : "No"}</div>
                            </div>
                        </div>
                        )}

            {/* ENABLE QR CODE REPORT */}
            {/* {(props.roles[0] === USERTYPES.ADMIN ||
              props.roles[0] === USERTYPES.FIRMTECHNICIAN) && (
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.enable-qr-code")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>{props.values.enableQRCodeInReport ? "Yes" : "No"}</div>
                </div>
              </div>
            )} */}




             {/* ENABLE UNASSIGNMENT SERVICE 
            {(props.roles[0] === USERTYPES.FIRMADMIN) && (
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.enable-unassignment-service")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>{props.values.enableUnassignmentService ? "Yes" : "No"}</div>
                </div>
              </div>
            )}*/}


            {/* ENABLE MS WORD */}
            {/* {!props.ownFirm && (props.roles[0] === USERTYPES.ADMIN || (props.roles[0] === USERTYPES.FIRMADMIN)) && (
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.enable-ms-word")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>{props.values.showWord ? "Yes" : "No"}</div>
                </div>
              </div>
            )} */}

            {/* ACCOUNT WARNING */}
            {!props.ownFirm &&
              (props.roles[0] === USERTYPES.FIRMADMIN ||
                props.roles[0] === USERTYPES.SUPERVISOR) && (
                <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                    <div className="form-heading">
                      {t("hospital.account-warning")}
                    </div>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                    <div>
                      {props.values.accountWarning
                        ? props.values.accountWarning
                        : "-"}
                    </div>
                  </div>
                </div>
              )}

{/* { (props.roles[0] === USERTYPES.ADMIN ||
              (props.roles[0] === USERTYPES.FIRMADMIN && props.ownFirm))&& (
                  <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <div className="form-heading">
                        {t("hospital.technician-contact-mandatory")}
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                      <div>{props.values.technicianContactMandatory ? "Yes" : "No"}</div>
                    </div>
                  </div>
                )} */}
            {!props.ownFirm && props.roles[0] === USERTYPES.FIRMADMIN && (
              <>
                {!enterprise && !props.values.isClientWarning && (
                  <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <div className="form-heading">
                        {t("hospital.history-available")}
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                      <div>{props.values.historyAvailable ? "Yes" : "No"}</div>
                    </div>
                  </div>
                )}
                
                {(props.roles[0] === USERTYPES.FIRMADMIN ||
                  props.roles[0] === USERTYPES.SUPERVISOR) && (
                  <>
                    <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                        <div className="form-heading">
                          {t("hospital.enable-print-disclaimer")}
                        </div>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                        <div>
                          {props.values.addPrintDisclaimer ? "Yes" : "No"}
                        </div>
                      </div>
                    </div>
                    {!!enablePrintDisclaimerText && (
                      <div
                        className="ms-Grid-row"
                        style={{ minHeight: "40px" }}
                      >
                        <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                          <div className="form-heading">Print Disclaimer</div>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                          <div>
                            {props.values.printDisclaimerText
                              ? props.values.printDisclaimerText
                              : "0"}
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
                {!enterprise && !props.values.isClientWarning && (
                  <>
                    <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                        <div className="form-heading">
                          {t("hospital.enable-quality-check")}
                        </div>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                        <div>{props.values.qcEnabled || props.values.preliminaryQcEnabled ? "Yes" : "No"}</div>
                      </div>
                    </div>
                    {!!qcEnabled && (
                      <>
                        <div
                          className="ms-Grid-row"
                          style={{ minHeight: "40px" }}
                        >
                          <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                            <div className="form-heading">
                              {t("hospital.qc-type")}
                            </div>
                          </div>
                          <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                            <div>
                              {props.values.preliminaryQcEnabled
                                ? t("hospital.preliminary-qc")
                                : t("hospital.final-qc")}
                            </div>
                          </div>
                        </div>
                        <div
                          className="ms-Grid-row"
                          style={{ minHeight: "40px" }}
                        >
                          <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                            <div className="form-heading">
                              {t("hospital.allow-two-signatures")}
                            </div>
                          </div>
                          <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                            <div>
                              {props.values.twoSignaturesAllowed ? "Yes" : "No"}
                            </div>
                          </div>
                        </div>
                        {/* add modality ids part */}
                        <div
                          className="ms-Grid-row"
                          style={{ minHeight: "40px" }}
                        >
                          <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                            <div className="form-heading">
                              {t("hospital.modality")}
                            </div>
                          </div>
                          <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                            <div>{props.values.modalityIds}</div>
                          </div>
                        </div>
                        <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                          <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                            <div className="form-heading">
                              {t("hospital.enable-qc-auto-assignment")}
                            </div>
                          </div>
                          <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                            <div>
                              {props.values.enableQCAutoAssignment ? "Yes" : "No"}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                        <div className="form-heading">
                          {t("hospital.enable-auto-assignment")}
                        </div>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                        <div>
                          {props.values.autoAssignEnable ? "Yes" : "No"}
                        </div>
                      </div>
                    </div>
                    {!!autoAssignEnabled && (
                      <div
                        className="ms-Grid-row"
                        style={{ minHeight: "40px" }}
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                          <div className="form-heading">
                            {t("hospital.modality")}
                          </div>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                          <div>{props.values.autoAssignModalityIds}</div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </>
            )}
            {props.roles[0] === USERTYPES.FIRMADMIN && (
                <>
                  <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <div className="form-heading">
                        {t("hospital.sub_modality_list_number")}
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <div>
                        {props.values.selectedSubModalityListNumber
                          ? props.values.selectedSubModalityListNumber
                          : "-"}
                      </div>
                    </div>
                  </div>
                  <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <div className="form-heading">
                        {t("hospital.branch-code")}
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                      <div>
                        {props.values.branchCode
                          ? props.values.branchCode
                          : "-"}
                      </div>
                    </div>
                  </div>
                </>
              )}

             {/* --- CLIENT COMMUNICATION FLAGS --- */}
        {(props.roles[0] === USERTYPES.ADMIN  && (!props.isMinimalAccount || props.isMinimalAccount === "false") && isEnableWhatsApp) && (
            <>
                {/* 1. Master Flag: Allow firm admin to set client communication */}
                <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                        <div className="form-heading">
                            Allow firm admin to set client communication
                        </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                        <div>
                            {props.values.allowFirmAdminSetClientComm ? "Yes" : "No"}
                        </div>
                    </div>
                </div>

                {/* 2. Sub-flag: Allow firm admin to enable WhatsApp? */}
                {props.values.allowFirmAdminSetClientComm && ( // Only show sub-flags if master is 'Yes'
                    <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                            <div className="form-heading">
                                Allow firm admin to enable WhatsApp
                            </div>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                            <div>
                                {props.values.firmAdminCanEnableWhatsapp ? "Yes" : "No"}
                            </div>
                        </div>
                    </div>
                )}

                {/* 3. Sub-flag: Allow firm admin to enable Email? */}
                {props.values.allowFirmAdminSetClientComm && ( // Only show sub-flags if master is 'Yes'
                    <div className="ms-Grid-row" style={{ minHeight: "40px"}}>
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                            <div className="form-heading">
                                Allow firm admin to enable Email
                            </div>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                            <div>
                                {props.values.firmAdminCanEnableEmail ? "Yes" : "No"}
                            </div>
                        </div>
                    </div>
                )}
            </>
        )}
        {/* --- END CLIENT COMMUNICATION FLAGS --- */}
          <div className="ms-Grid-row" style={{ minHeight: "40px"}}>
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                            <div className="form-heading">
      {t("account-and-settings.timezone") || "Time Zone"}
    </div>
  </div>

  <div
    className="ms-Grid-col ms-sm6 ms-lg4 ms-xl4 single-line-form-field-value"
    style={{
      display: "flex",
      alignItems: "center",
    }}
  ><p>{
          props.values.firmTimeZone
            ? props.values.firmTimeZone
            : getEnv("REACT_APP_BACKEND_TIMEZONE") || "-"
        }
      </p>
    </div>
</div>


           {isBucketManagement && (props.roles[0] === USERTYPES.ADMIN || props.roles[0] === USERTYPES.FIRMADMIN) && (
              <fieldset className="border rounded p-4 fieldset-bucket-config">
                <legend className="font-bold">{t("Bucket Configuration")}</legend>

                {props.values.modalityBuckets && props.values.modalityBuckets.length > 0 ? (
                  props.values.modalityBuckets.map((item, idx) => (
                    <div key={idx} style={{ display: 'flex', marginBottom: 8, alignItems: 'center' }}>
                      <div style={{ width: 200, marginRight: 8 }}>
                        <label className="form-heading">{t("Modality")}</label>
                        <div style={{ paddingTop: 4 }}>
                          {bucketModalityList.find(o => o.key === item.modality)?.text || item.modality || "-"}
                        </div>
                      </div>
                      <div style={{ width: 200, marginRight: 8 }}>
                        <label className="form-heading">{t("Bucket Configuration")}</label>
                        <div style={{ paddingTop: 4 }}>
                          {bucketOptions.find(o => o.key === item.bucketConfiguration)?.text || item.bucketConfiguration || "-"}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div>{t("No modality buckets assigned")}</div>
                )}
              </fieldset>
            )}
           
          </div>
        </div>
      )}
    </>
  );
};

export default HospitalSettings;
